import React from "react"
import useTranslation from "../../../hooks/useTranslation"
import { ArrowRightIcon } from "../../Icons"
import { Html } from "../../index"

export const NextLabel = ({ labelKey = "next" }) => {
  const { translate } = useTranslation()

  return (
    <>
      <Html content={translate(labelKey)} />
      &nbsp;
      <ArrowRightIcon />
    </>
  )
}
